import { NextSeoProps } from "next-seo";

const DEFAULT_SEO: NextSeoProps = {
  titleTemplate: "%s | Trend",
  defaultTitle: "Trend Creators",
  description:
    "Trend connects brands with content creators in order to scale user-generated content across a variety of platforms while increasing their marketing ROI.",
  openGraph: {
    type: "website",
    locale: "en_IE",
    url: "https://creators.trend.io/",
    site_name: "Trend Creators",
    images: [{ url: process.env.NEXT_PUBLIC_OPENGRAPH_IMAGE || '' }],
    description:
      "Trend connects brands with content creators in order to scale user-generated content across a variety of platforms while increasing their marketing ROI.",
  },
  twitter: {
    handle: "@trend_io",
    site: "@trend_io",
    cardType: "summary_large_image",
  },
};

export { DEFAULT_SEO };
